import { Pipe, PipeTransform } from '@angular/core';

import { GameType } from '../models/communication/app-enums.model';

@Pipe({
    name: 'gameLabel',
    standalone: true
})
export class GameLabelPipe implements PipeTransform {
    transform(value?: GameType): string {
        return GameLabelPipe.gameTypeToLabel(value);
    }

    static gameTypeToLabel(value?: GameType): string {
        switch (value) {
            case GameType.Baccarat:
                return $localize`Baccarat`;
            case GameType.DragonTiger:
                return $localize`Dragon Tiger`;
            case GameType.ThreeHeadedDragon:
                return $localize`Three Headed Dragon`;
            case GameType.OpenBaccarat:
                return $localize`Open Baccarat`;
            case GameType.OpenDragonTiger:
                return $localize`Open Dragon Tiger`;
            default:
                // eslint-disable-next-line no-console
                console.warn(`Unknown game type: ${String(value)}`);
                return '';
        }
    }
}
